__turbopack_context__.v({
  "icon": "QuestionAnswerBlock-module-scss-module__62QwoG__icon",
  "text": "QuestionAnswerBlock-module-scss-module__62QwoG__text",
  "wrapper": "QuestionAnswerBlock-module-scss-module__62QwoG__wrapper",
});
